import { apiRequest } from "./client";

export type Theme = "light" | "dark" | null;
export type Language = "en" | "de";

export interface UserSettings {
  theme: Theme;
  language: Language | null;
}

export function getSettings(): Promise<UserSettings> {
  return apiRequest<UserSettings>("/settings");
}

export function updateSettings(
  patch: Partial<UserSettings>,
): Promise<UserSettings> {
  return apiRequest<UserSettings>("/settings", {
    method: "PUT",
    body: JSON.stringify(patch),
  });
}
